import styled from "styled-components";
import { IoIosArrowDown } from "react-icons/io";

const Wrapper = styled.div`
  width: 100%;
  max-width: 887px;
  display: flex;
  justify-content: flex-start;
`;

const DropdownContainer = styled.div`
  width: 100%;
  max-width: 300px;
  background-color: white;
  border: 2px solid #dcdcdc;
  display: flex;
  align-items: center;
  padding: 8px 10px;
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  box-sizing: border-box;

  overflow: visible; 
`;

const SelectedText = styled.span`
  flex: 1;
  min-width: 0;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DropdownIcon = styled(IoIosArrowDown)`
  width: 24px;
  height: 24px;
  color: gray;
  margin-left: 8px;
  flex-shrink: 0;
`;

const DropdownList = styled.ul`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  list-style: none;
  padding: 6px 0;
  margin: 0;
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};

  z-index: 9999;         
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;

  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
`;

const DropdownItem = styled.li`
  padding: 10px 12px;
  font-size: 16px;
  cursor: pointer;
  line-height: 1.2;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export {
  Wrapper,
  DropdownContainer,
  SelectedText,
  DropdownIcon,
  DropdownList,
  DropdownItem,
};